/**
 * Appointment duration bounds in minutes — mirror the backend validation (5-480).
 */
export const MIN_DURATION = 5;
export const MAX_DURATION = 480;
export const DURATION_STEP = 5;

/**
 * Start times move by 5-minute steps, and the server accepts a start from
 * the current step on: a walk-in at 14:32 still books 14:30.
 */
export const START_STEP_MINUTES = 5;

export const PAST_APPOINTMENT_MESSAGE = 'Un rendez-vous ne peut pas être placé dans le passé.';

/**
 * Default color for types without one. It mirrors colors.primary.DEFAULT
 * (src/theme/colors.ts) and the backend default, uppercase to match the
 * backend's stored format. A type without an icon has none: no default.
 */
export const DEFAULT_APPOINTMENT_COLOR = '#3513E2';

/**
 * Color palette, aligned with the backend default catalog colors.
 */
export const APPOINTMENT_COLORS = [
    DEFAULT_APPOINTMENT_COLOR,
    '#AB74E0',
    '#0EA5E9',
    '#16A34A',
    '#F59E0B',
    '#DB2777',
    '#DC2626',
    '#64748B'
];

/**
 * Rank of a healthcenter patient access (UserAccessRank::HEALTHCENTER_PATIENT_RANK_ID
 * server-side): excluded from the staff lists.
 */
export const PATIENT_RANK_ID = 12;

/**
 * Day-view grid bounds (hours) and geometry. The grid extends automatically
 * when an appointment falls outside these default bounds.
 */
export const DAY_START_HOUR = 7;
export const DAY_END_HOUR = 21;
export const HOUR_HEIGHT_PX = 64;
export const SLOT_MINUTES = 15;

/**
 * Width of the hour axis gutter, and the width below which a column is not
 * worth drawing: past that many columns the grid scrolls horizontally instead
 * of squeezing them. Both rows of the grid derive their total width from these,
 * which is what keeps a header above its own column.
 */
export const HOUR_AXIS_WIDTH_PX = 56;
export const LANE_MIN_WIDTH_PX = 120;

/**
 * Frequentation overlay geometry: the width of the day view's colored strip,
 * and the opacity of the week view's column backgrounds. The scale being a
 * violet ramp whose top step is saturated, the backgrounds are held further
 * back than the strip — behind a whole column, a full-strength tint would
 * compete with the appointments it is meant to inform.
 */
export const FREQUENTATION_COLUMN_WIDTH_PX = 10;
export const FREQUENTATION_BACKGROUND_OPACITY = 0.4;

/**
 * Appointments a month cell lists before falling back to a "+N" summary. Two
 * fit the cell's minimum height whatever the window, so the grid never goes
 * ragged; the rest stays one click away in the day's popover.
 */
export const MONTH_CELL_APPOINTMENTS = 2;

/**
 * Icon choices, as Lucide names — the value stored by the backend and the one
 * CatalogIcon resolves. They were mdi names until the front moved to Lucide;
 * a migration translated the rows already in database.
 */
export const APPOINTMENT_ICONS = [
    'calendar',
    'syringe',
    'message-circle',
    'clipboard-plus',
    'test-tube',
    'baby',
    'pill',
    'heart-pulse',
    'stethoscope',
    'heart-handshake'
];
